import { OverallValidationResult, validator } from '../../../tradebuilder-v2/util'
import { EditCashInstrumentsState } from '../edit-cash-instruments-slice'
import { editCashInstrumentRules } from './edit-cash-instrument'

const editCashInstrumentValidator = validator(editCashInstrumentRules)

export function validate(cashInstrumentState: EditCashInstrumentsState): OverallValidationResult {
  return editCashInstrumentValidator(cashInstrumentState)
}
